module.exports = __webpack_public_path__ + "static/media/top_logo2.253f1a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/top_logo2.png
// module id = 336
// module chunks = 0